import { render } from "./product_sells.vue?vue&type=template&id=68e761c6&scoped=true"
import script from "./product_sells.vue?vue&type=script&lang=js"
export * from "./product_sells.vue?vue&type=script&lang=js"

import "./product_sells.vue?vue&type=style&index=0&id=68e761c6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e761c6"]])

export default __exports__